<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Timeline</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="timeline-main-section col-12 float-l default-bx-shadow">
                <div class="row">

                    <div class="timeline">
                      <template v-for="item in posts">
                        <div class="justify-content-end justify-content-md-around align-items-start  timeline-nodes"> <!--right side-->
                            <div class="col-10 col-md-5 order-3 order-md-1 timeline-content default-bx-shadow" v-bind:style="statusStyle(item.status)">
                                <!-- TITLE -->
                                <h6 class="float-r"> {{ capitalize(item.status) }}</h6>
                                <h3>{{ item.title }}</h3>
                                <!-- TIME -->
                                <h5> {{ moment(item.start_date_time) }}</h5>
                                <h6> Company: {{ item.company }}</h6>
                                <h7> Social Media: {{ capitalizeFirstLetter(item.social_media_type) }}</h7>
                                <br>
                                <!-- <h7> Post User: {{ capitalizeFirstLetter(item.post_user) }}</h7> -->
                                <!-- POST MEDIA -->
                                <template v-for="media_img in item.media">

                                  <!--div class="hover-home-eefect employee-border timeline-img">
                                      <a class="image-zoom timeline-img" :href="imageUrl(media_img.document)" rel="prettyPhoto[gallery]" :title="item.title">
                                          <img :src="imageUrl(media_img.document)" style="height: 50%;"/>
                                      </a>
                                  </div-->
                                  <template v-if="media_img.file_type == 'video/mp4'">
                                    <div class="swiper-slide swiper-slide-active" style="width: 40.1034px; margin-right: 8px;background-color:transparent;">
                                      <img src="/static/images/video-icon.png" class="timeline-img">
                                    </div>
                                  </template>

                                  <template v-if="media_img.file_type != 'video/mp4'">
                                    <img class="timeline-img" :src="imageUrl(media_img.document)" style="height: 50%;">
                                  </template>

                                </template>
                                <!-- DESCRIPTION -->
                                <p v-html="item.description" style="overflow: auto;"></p>
                                <!-- Hashtag -->
                                <div>
                                  <template v-if="item.has_tags != ''">
                                    <template v-for="(tags , index) in hashTagSet(item.has_tags)">
                                      <a :href="hashTagUrl(tags)" target="_blank">{{ tags }} </a>
                                    </template>
                                  </template>
                                </div>
                                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="deletePost(item)">
                                Delete</button>
                            </div>
                            <!--div class="col-2 col-sm-1 order-2 timeline-image text-md-center">
                            < USER ICON >
                                <img src="http://localhost:8081/static/images/avtar-img.jpg" class="img-fluid" alt="img">
                            </div-->
                            <div class="col-10 col-md-5 order-1 order-md-3 py-3 timeline-date">
                            </div>
                        </div>
                      </template>
                    </div> <!--Time line-->



                </div>

                </div>
            </div>

            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    var self;
    export default {
        name: 'Center',
        mixins: [SessioMixin],
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
              noOfRec : 25,
              skip : 0,
              loginID : 0,
              posts : "",
              draftColor : false,
            }

        },
        beforeMount: function () {
          self = this;
          self.checkLogin();
        },
        mounted: function () {
          this.scroll();
          self.getPosts();
          var userObj = localStorage.getItem("user_obj");
          if (userObj != null) {
              var userJson = JSON.parse(userObj);
              self.loginID = userJson.id;
          }

        },
        methods: {
          capitalize: function (value) {
            if (typeof value !== 'string') return ''
            return value.charAt(0).toUpperCase() + value.slice(1)
          },
          statusStyle: function(status) {
            console.log(status);
            if(status == 'draft') {
              return {
                active: true,
                'background-color': '#6200ff17'
              }
            } else if(status == 'published') {
              return {
                active: true,
                'background-color': '#00f4ff2e'
              }
            } else if(status == 'failed') {
              return {
                active: true,
                'background-color': '#f1000029'
              }
            } else if(status == 'post') {
              return {
                active: true,
                'background-color': '#4bff0030'
              }
            } else if(status == 'Time Missing' || status == 'time missing') {
              return {
                active: true,
                'background-color': '#00ffff'
              }
            }



          },
          deletePost: function (item) {
            console.log(item);

            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            };
            var fields = {
                id: item.id,
                user_id: self.loginID,
                social_media_id: item.social_media_id,
            };

            this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.showLoader();
                      HTTP.post('socialmedia/delete',fields, config)
                          .then(function (response) {
                            console.log('self.posts =',response);
                              if (response.data.status == "success") {
                                self.posts = "";
                                self.$swal('Deleted', 'You successfully deleted post', 'success')
                                self.getPosts();
                              }
                              self.hideLoader();
                          })
                          .catch(function (err) {
                              if (err.response.status == 0) {
                                  if (err.response.status == 0) {
                                      self.error = "Remote server can not be reachable";
                                  } else {
                                      //redirect to login page if user not authenticated
                                      if (err.response.status == 401) {
                                          //clear previous data
                                          localStorage.removeItem("user_obj");
                                          localStorage.removeItem("api_token");
                                          localStorage.removeItem("profile_image");
                                          self.$router.push("/login");
                                          //EventBus.$emit("logged-in", true, "", "");
                                      }
                                      self.error = err.response.data.message;
                                  }
                              }
                              self.hideLoader();
                          });
                    } else {
                        self.$swal('Cancelled', 'Your post is still there', 'info')
                    }
                })




          },
          hashTagUrl(tag) {

            return "https://www.google.com/search?q=" + tag.replace('#', '');
          },
          hashTagSet: function(tags) {
            var res = tags.split(" ");
            return res;
          },
          imageUrl(image) {
            // video/mp4
            return process.env.BUCKET_FILE_PREFIX + image;
            // "/api/" +
          },
          moment: function (date) {
            return moment(date).format('MMMM Do YYYY, h:mm:ss a');
          },
          getPosts: function() {
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            };
            var fields = {
                no_rec: self.noOfRec,
                skip: self.skip,
            };
            self.showLoader();
            HTTP.post('socialmedia/getTimeline',fields, config)
                .then(function (response) {
                  console.log('self.posts =',response);
                    if (response.status == '200') {


                      if(self.posts == "") {
                        self.posts = response.data.content;
                      } else {
                        response.data.content.forEach(element => {
                          self.posts.push(element);
                        });

                      }
                      console.log('self.posts =',self.posts.length);


                    }
                    self.hideLoader();
                })
                .catch(function (err) {
                  console.log(err);
                    if (err.response.status == 0) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    }
                    self.hideLoader();
                })

          },
          scroll () {

            var path = window.location.pathname;
            var segments = path.split("/");
            // backend/social/timeline
            if (segments[2] == 'social') {
                if (segments[3] == 'timeline') {
                  console.log("SCROLL");

                  window.onscroll = () => {
                    let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

                    if (bottomOfWindow) {
                      console.log(bottomOfWindow);
                      if(self.skip == 0) {
                        self.skip = 25;
                      } else {
                        self.skip +=  self.skip;
                      }
                      self.getPosts();

                    }
                  };

                }
            }
        },




        }
    }
</script>
<style scoped>
.draftColor {
  background-color: #6200ff17;
}
.publishedColor {
  background-color: #00f4ff2e;
}

</style>



// WEBPACK FOOTER //
// src/components/backend/socialmedia/PostTimeline.vue